import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';
import { DataService } from '../services/data.service';
import { StoreComponent, StorageDialogComponent} from '../store/store.component';
import { StorageFormComponent } from './storage-form/storage-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    StoreComponent,
    StorageDialogComponent,
    StorageFormComponent
  ],
  entryComponents: [
    StorageDialogComponent
  ],
  providers: [DataService]
})
export class StoreModule { }



// WEBPACK FOOTER //
// ./src/app/store/store.module.ts